module.exports = __webpack_public_path__ + "img/dis-r-4.0d3006d9.png";